import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

// Teach the merger our typography scale so text-compact does not erase a
// foreground color such as text-text-on-action on buttons and badges.
const merge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: ['display', 'headline', 'title', 'subtitle', 'body', 'compact', 'caption', 'eyebrow'] }],
    },
  },
})

export function cn(...inputs: ClassValue[]): string {
  return merge(clsx(inputs))
}
